import React, { useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import {
  Card,
  SearchableSelect,
  LabMachineAnalysis,
  Lottie,
} from "../../components";
import { AVAILABLE_SERVICES } from "../../utils/constants";
import { AnalysisProps } from "../../utils/types/containers";
import WaitingAnimation from "../../assets/lotties/lf20_2RSPTv.json";
import { setOpen } from "../../redux/reducers/modalScreen";

const SERVICES = _.values(AVAILABLE_SERVICES);

const Analysis = ({
  user,
  onSetOpenModalScreen,
}: AnalysisProps): React.ReactElement => {
  const [serviceSelected, setServiceSelected] = useState(null);

  const getView = (sv: string): React.ReactElement => {
    switch (sv) {
      case AVAILABLE_SERVICES.SV1:
        return (
          <LabMachineAnalysis
            onLoading={onSetOpenModalScreen}
            faenas={user?.faenas || []}
          />
        );

      default:
        return (
          <div>
            <Lottie animationData={WaitingAnimation} width={600} height={500} />
          </div>
        );
    }
  };

  return (
    <Card type="principal" title="Analisis de Servicios">
      <SearchableSelect
        label="Servicio"
        options={SERVICES}
        getOptionLabel={(opt: string) => opt}
        onChange={(y) => setServiceSelected(y)}
        style={{ marginTop: 30, marginBottom: 30 }}
      />

      {getView(serviceSelected)}
    </Card>
  );
};

const mapStateToProps = (state: Record<string, Record<string, any>>) => ({
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch: (value: any) => unknown) => ({
  onSetOpenModalScreen: (open) => dispatch(setOpen(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Analysis);
